import React from 'react'
import CommonTile from '../component/commonTile'
import TweenOne from 'rc-tween-one';
import Children from 'rc-tween-one/lib/plugin/ChildrenPlugin'
TweenOne.plugins.push(Children)

import './index.less'
import { OverPack } from 'rc-scroll-anim';

const partner = require('../../../assets/image/home/home_logo_v1.3.png')
export default function Page6() {

  return (
    <div>
      <OverPack playScale={0.15} always={false}>
        <div className='home-result'>
          <CommonTile title="技术成果" subTitle="具备区块链、计算机、大数据、金融、数学等多个方向的研究背景" />
          <div className="home-result-inner">
              <div>
                <div className='result-num-content'>
                  <TweenOne
                    className="result-num"
                    animation={{ Children: { value: 6, floatLength: 0 }, duration: 300 }}>
                    0
                  </TweenOne>
                </div>
                <div className="result-title">国家级区块链创新试点</div>
              </div>
              <div>
                <div className='result-num-content'>
                  <TweenOne
                    className="result-num"
                    animation={{ Children: { value: 4, floatLength: 0 }, duration: 300 }}>
                    0
                  </TweenOne>
                </div>
                <div className="result-title">著作</div>
              </div>
              <div>
                <div className='result-num-content'>
                  <TweenOne
                    className="result-num"
                    animation={{ Children: { value: 20, floatLength: 0 }, duration: 300 }}>
                    0
                  </TweenOne>
                  <div className='result-num-plus'>+</div>
                </div>
                <div className="result-title">论文</div>
              </div>
              <div>
                <div className='result-num-content'>
                  <TweenOne
                    className="result-num"
                    animation={{ Children: { value: 200, floatLength: 0 }, duration: 300 }}>
                    0
                  </TweenOne>
                  <div className='result-num-plus'>+</div>
                </div>
                <div className="result-title">专利</div>
              </div>
              <div>
                <div className='result-num-content'>
                  <TweenOne
                    className="result-num"
                    animation={{ Children: { value: 50, floatLength: 0 }, duration: 300 }}>
                    0
                  </TweenOne>
                  <div className='result-num-plus'>+</div>
                </div>
                <div className="result-title">软著</div>
              </div>
          </div>
        </div>
      </OverPack>
    </div>
  )
}
